import React from 'react';
import Header from '../../components/ui/Header';
import ResidentialHero from './components/ResidentialHero';
import SustainabilityBenefits from './components/SustainabilityBenefits';
import LocationAdvantages from './components/LocationAdvantages';
import ComingSoon from './components/ComingSoon';

const ResidentialApartments = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="pt-16">
        <ResidentialHero />
        <SustainabilityBenefits />
        <LocationAdvantages />
        <ComingSoon />
      </div>
    </div>
  );
};

export default ResidentialApartments;
